/** @jsx jsx */
import { jsx, ThemeProvider, ColorMode } from 'theme-ui';
import theme from './index';
import components from './components';
export var wrapRootElement = function wrapRootElement(_ref, opts) {
  var element = _ref.element;
  return jsx(ThemeProvider, {
    theme: theme,
    components: components
  }, theme.initialColorMode && jsx(ColorMode, {
    key: 'theme-ui-color-mode'
  }), element);
};